<template>
    <div
        class="group relative cursor-pointer overflow-hidden bg-card shadow-xl shadow-brand-500/10 transition-shadow duration-300 hover:shadow-2xl hover:shadow-brand-500/25">
        <!-- Photo -->
        <div class="aspect-[360/470] w-full overflow-hidden bg-brand-500/10">
            <img v-if="speaker.photoUrl" :src="speaker.photoUrl" :alt="speaker.name"
                class="h-full w-full object-cover object-top" />
            <div v-else class="flex h-full w-full items-center justify-center text-5xl font-black text-brand-500">
                {{ initials(speaker.name) }}
            </div>
        </div>

        <!-- Social pill, straddling the photo / footer edge -->
        <div v-if="speaker.socials?.length"
            class="absolute inset-x-0 bottom-[5.5rem] z-10 flex translate-y-3 justify-center opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:translate-y-0 group-focus-within:opacity-100">
            <div class="flex items-center gap-1 rounded-full bg-white px-4 py-2.5 shadow-lg">
                <a v-for="(s, i) in speaker.socials" :key="i" :href="s.url" target="_blank" rel="noopener"
                    :title="socialLabel(s.platform)" @click.stop
                    class="flex h-6 w-8 items-center justify-center text-slate-500 transition-colors hover:text-brand-500">
                    <component :is="socialIcon(s.platform)" class="h-4 w-4" />
                </a>
            </div>
        </div>

        <!-- Footer: white at rest, brand gradient on hover -->
        <div class="relative px-4 py-5 text-center">
            <div
                class="absolute inset-0 bg-gradient-to-r from-brand-700 to-brand-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            </div>
            <div class="relative">
                <h3 class="text-header text-xl font-bold leading-snug transition-colors duration-300 group-hover:text-white">
                    {{ speaker.name }}
                </h3>
                <p v-if="speaker.role || speaker.designation"
                    class="mt-0.5 text-sm text-brand-500 transition-colors duration-300 group-hover:text-white/90">
                    {{ speaker.role || speaker.designation }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { EventSpeaker } from '~/types';
import { initials, socialIcon, socialLabel } from '../helpers';

defineProps<{ speaker: EventSpeaker }>();
</script>

<style scoped>
.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.text-header {
    color: rgb(var(--core-header-text));
}
</style>
